import { IJsonSerializable } from "../util/interfaces";
import { TypeHelper } from "../../helpers/type-helper";

export class OpDBScriptParam implements IJsonSerializable {

    // Members

    public idDBScript: number
    public fieldName: string
    public idUnit: number
    public name: string
    public idReference: number
    public idDataTypeClass: number
    public isInputParam: boolean
    public isVisible: boolean
    public defaultValue: any
    public format: string
    public isCollection: boolean
    public value: any

    // Members End

    // Ctor

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    // Ctor

    // IJsonSerializable Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            if (compressed || TypeHelper.isJSONCompressed(opObj)) {
                this.idDBScript = opObj.IDS
                this.fieldName = opObj.F
                this.idUnit = opObj.I
                this.name = opObj.N
                this.idReference = opObj.IR
                this.idDataTypeClass = opObj.IDT
                this.isInputParam = opObj.IIP
                this.isVisible = opObj.IV
                this.defaultValue = opObj.DV
                this.format = opObj.FT
                this.isCollection = opObj.IC
                this.value = opObj.V
            } else {
                this.idDBScript = opObj.IdDBScript
                this.fieldName = opObj.FieldName
                this.idUnit = opObj.IdUnit
                this.name = opObj.Name
                this.idReference = opObj.IdReference
                this.idDataTypeClass = opObj.IdDataTypeClass
                this.isInputParam = opObj.IsInputParam
                this.isVisible = opObj.IsVisible
                this.defaultValue = opObj.DefaultValue
                this.format = opObj.Format
                this.isCollection = opObj.IsCollection
                this.value = opObj.Value
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        if (compressed) {
            const result: any = {
                IDS: this.idDBScript,
                F: this.fieldName,
                I: this.idUnit,
                N: this.name,
                IR: this.idReference,
                IDT: this.idDataTypeClass,
                IIP: this.isInputParam,
                IV: this.isVisible,
                DV: this.defaultValue,
                FT: this.format,
                IC: this.isCollection,
                V: this.value
            }
            TypeHelper.setJSONCompressedFlag(result)
            TypeHelper.deleteNulls(result)

            return result
        }
            return {
                IdDBScript: this.idDBScript,
                FieldName: this.fieldName,
                IdUnit: this.idUnit,
                Name: this.name,
                IdReference: this.idReference,
                IdDataTypeClass: this.idDataTypeClass,
                IsInputParam: this.isInputParam,
                IsVisible: this.isVisible,
                DefaultValue: this.defaultValue,
                Format: this.format,
                IsCollection: this.isCollection,
                Value: this.value
            }
        }
        // IJsonSerializable Implementation End
    }


